import { IconComponent } from "types/Icon";

// * FYI: these values are used in the useIacManagementResources hook to filter the data
export enum IacManagementGroupBy {
  Stack = "stack",
  Provider = "provider",
  Type = "type",
  None = "none",
}

export type IacManagementStackVendorMeta = {
  icon: IconComponent;
  text: string;
};
